import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const StopListSyncIntervalField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { t } = useTranslation('form');
	const interval = customerForFullInfo?.stopListSyncIntervalMinutes;

	return (
		<FullInfoField
			label="stopListSyncIntervalLabel"
			value={interval ? t('stopListSyncIntervalValue', { value: interval }) : null}
		/>
	);
};
